/* eslint-disable guard-for-in */
import Fetch, { V1 } from 'Util/fetcher';

// will be depecrated
//= ============================================================================================//
//                                  CREATE WATCHLIST GROUP                                      //
//= ============================================================================================//

const ON_CREATE_WATCHLIST_GROUP = 'ON_CREATE_WATCHLIST_GROUP';
const ON_CREATE_WATCHLIST_GROUP_SUCCESS = 'ON_CREATE_WATCHLIST_GROUP_SUCCESS';
const ON_CREATE_WATCHLIST_GROUP_FAILURE = 'ON_CREATE_WATCHLIST_GROUP_FAILURE';

function onCreateWatchlistGroup() {
  return {
    type: ON_CREATE_WATCHLIST_GROUP,
  };
}

function onCreateWatchlistGroupSuccess(payload) {
  return {
    type: ON_CREATE_WATCHLIST_GROUP_SUCCESS,
    payload,
  };
}

function onCreateWatchlistGroupFailure(payload) {
  return {
    type: ON_CREATE_WATCHLIST_GROUP_FAILURE,
    payload,
  };
}

export const onDoCreateWatchlistGroup = (payload) => (dispatch) => {
  dispatch(onCreateWatchlistGroup());
  Fetch.post(`${V1}stock/watchlist/group/`, payload)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onCreateWatchlistGroupSuccess(resp.json));
      } else {
        dispatch(onCreateWatchlistGroupFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onCreateWatchlistGroupFailure(error.message));
    });
};

//= ============================================================================================//
//                                            GET LIST WATCHLIST GROUP                          //
//= ============================================================================================//

const ON_REQUEST_WATCHLIST_GROUP = 'ON_REQUEST_WATCHLIST_GROUP';
const ON_REQUEST_WATCHLIST_GROUP_SUCCESS = 'ON_REQUEST_WATCHLIST_GROUP_SUCCESS';
const ON_REQUEST_WATCHLIST_GROUP_FAILURE = 'ON_REQUEST_WATCHLIST_GROUP_FAILURE';

function onRequestWatchlistGroup() {
  return {
    type: ON_REQUEST_WATCHLIST_GROUP,
  };
}

function onRequestWatchlistGroupSuccess(payload) {
  return {
    type: ON_REQUEST_WATCHLIST_GROUP_SUCCESS,
    payload,
  };
}

function onRequestWatchlistGroupFailure(payload) {
  return {
    type: ON_REQUEST_WATCHLIST_GROUP_FAILURE,
    payload,
  };
}
export const onDoRequestWatchlistGroup = () => (dispatch) => {
  dispatch(onRequestWatchlistGroup());
  Fetch.get(`${V1}stock/watchlist/group/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestWatchlistGroupSuccess(resp.json));
      } else {
        dispatch(onRequestWatchlistGroupFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestWatchlistGroupFailure(error.message));
    });
};

//= ============================================================================================//
//                                            DELETE WATCHLIST GROUP                            //
//= ============================================================================================//

const ON_DELETE_WATCHLIST_GROUP = 'ON_DELETE_WATCHLIST_GROUP';
const ON_DELETE_WATCHLIST_GROUP_SUCCESS = 'ON_DELETE_WATCHLIST_GROUP_SUCCESS';
const ON_DELETE_WATCHLIST_GROUP_FAILURE = 'ON_DELETE_WATCHLIST_GROUP_FAILURE';

function onDeleteWatchlistGroup() {
  return {
    type: ON_DELETE_WATCHLIST_GROUP,
  };
}

function onDeleteWatchlistGroupSuccess(payload) {
  return {
    type: ON_DELETE_WATCHLIST_GROUP_SUCCESS,
    payload,
  };
}

function onDeleteWatchlistGroupFailure(payload) {
  return {
    type: ON_DELETE_WATCHLIST_GROUP_FAILURE,
    payload,
  };
}

export const onDoDeleteWatchlistGroup = (id) => (dispatch) => {
  dispatch(onDeleteWatchlistGroup());
  Fetch.delete(`${V1}stock/watchlist/group/${id}/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onDeleteWatchlistGroupSuccess(resp.json));
      } else {
        dispatch(onDeleteWatchlistGroupFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onDeleteWatchlistGroupFailure(error.message));
    });
};

//= ============================================================================================//
//                                           UPDATE WATCHLIST GROUP                             //
//= ============================================================================================//

const ON_UPDATE_WATCHLIST_GROUP = 'ON_UPDATE_WATCHLIST_GROUP';
const ON_UPDATE_WATCHLIST_GROUP_SUCCESS = 'ON_UPDATE_WATCHLIST_GROUP_SUCCESS';
const ON_UPDATE_WATCHLIST_GROUP_FAILURE = 'ON_UPDATE_WATCHLIST_GROUP_FAILURE';

function onUpdateWatchlistGroup() {
  return {
    type: ON_UPDATE_WATCHLIST_GROUP,
  };
}

function onUpdateWatchlistGroupSuccess(payload) {
  return {
    type: ON_UPDATE_WATCHLIST_GROUP_SUCCESS,
    payload,
  };
}

function onUpdateWatchlistGroupFailure(payload) {
  return {
    type: ON_UPDATE_WATCHLIST_GROUP_FAILURE,
    payload,
  };
}

export const onDoUpdateWatchlistGroup = (payload) => (dispatch) => {
  dispatch(onUpdateWatchlistGroup());
  Fetch.put(`${V1}stock/watchlist/group/`, payload)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onUpdateWatchlistGroupSuccess(resp.json));
      } else {
        dispatch(onUpdateWatchlistGroupFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onUpdateWatchlistGroupFailure(error.message));
    });
};

//= ============================================================================================//
//                                              SELECT GROUP                                    //
//= ============================================================================================//

const ON_SELECT_WATCHLIST_GROUP = 'ON_SELECT_WATCHLIST_GROUP';
const ON_SELECT_WATCHLIST_GROUP_SUCCESS = 'ON_SELECT_WATCHLIST_GROUP_SUCCESS';
const ON_SELECT_WATCHLIST_GROUP_FAILURE = 'ON_SELECT_WATCHLIST_GROUP_FAILURE';

function onSelectWatchlistGroup() {
  return {
    type: ON_SELECT_WATCHLIST_GROUP,
  };
}

function onSelectWatchlistGroupSuccess(payload) {
  return {
    type: ON_SELECT_WATCHLIST_GROUP_SUCCESS,
    payload,
  };
}

function onSelectWatchlistGroupFailure(payload) {
  return {
    type: ON_SELECT_WATCHLIST_GROUP_FAILURE,
    payload,
  };
}

export const onDoSelectWatchlistGroup = (id) => (dispatch) => {
  dispatch(onSelectWatchlistGroup());
  Fetch.post(`${V1}stock/watchlist/group/${id}/select/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onSelectWatchlistGroupSuccess(resp.json));
      } else {
        dispatch(onSelectWatchlistGroupFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onSelectWatchlistGroupFailure(error.message));
    });
};

//= ============================================================================================//
//                                   GET WATCHLIST GROUP NAME BY SELECTED ID                    //
//= ============================================================================================//

const ON_REQUEST_WATCHLIST_GROUP_BY_ID = 'ON_REQUEST_WATCHLIST_GROUP_BY_ID';
const ON_REQUEST_WATCHLIST_GROUP_BY_ID_SUCCESS = 'ON_REQUEST_WATCHLIST_GROUP_BY_ID_SUCCESS';
const ON_REQUEST_WATCHLIST_GROUP_BY_ID_FAILURE = 'ON_REQUEST_WATCHLIST_GROUP_BY_ID_FAILURE';

function onRequestWatchlistGroupById() {
  return {
    type: ON_REQUEST_WATCHLIST_GROUP_BY_ID,
  };
}

function onRequestWatchlistGroupByIdSuccess(payload) {
  return {
    type: ON_REQUEST_WATCHLIST_GROUP_BY_ID_SUCCESS,
    payload,
  };
}

function onRequestWatchlistGroupByIdFailure(payload) {
  return {
    type: ON_REQUEST_WATCHLIST_GROUP_BY_ID_FAILURE,
    payload,
  };
}
export const onDoRequestWatchlistGroupById = (id) => (dispatch) => {
  dispatch(onRequestWatchlistGroupById());
  Fetch.get(`${V1}stock/watchlist/group/${id}/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestWatchlistGroupByIdSuccess(resp.json));
      } else {
        dispatch(onRequestWatchlistGroupByIdFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestWatchlistGroupByIdFailure(error.message));
    });
};

//= ============================================================================================//
//                                         GET WATCHLIST CODE BY SELECTED ID                    //
//= ============================================================================================//

const ON_REQUEST_WATCHLIST_BY_ID = 'ON_REQUEST_WATCHLIST_BY_ID';
const ON_REQUEST_WATCHLIST_BY_ID_SUCCESS = 'ON_REQUEST_WATCHLIST_BY_ID_SUCCESS';
const ON_REQUEST_WATCHLIST_BY_ID_FAILURE = 'ON_REQUEST_WATCHLIST_BY_ID_FAILURE';

function onRequestWatchlistById() {
  return {
    type: ON_REQUEST_WATCHLIST_BY_ID,
  };
}

function onRequestWatchlistByIdSuccess(payload) {
  return {
    type: ON_REQUEST_WATCHLIST_BY_ID_SUCCESS,
    payload,
  };
}

function onRequestWatchlistByIdFailure(payload) {
  return {
    type: ON_REQUEST_WATCHLIST_BY_ID_FAILURE,
    payload,
  };
}
export const onDoRequestWatchlistById = () => (dispatch) => {
  dispatch(onRequestWatchlistById());
  Fetch.get(`${V1}stock/watchlist/group/member/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestWatchlistByIdSuccess(resp.json));
      } else {
        dispatch(onRequestWatchlistByIdFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestWatchlistByIdFailure(error.message));
    });
};

//= ============================================================================================//
//                                           ADD TICKER TO WATCHLIST GROUP                      //
//= ============================================================================================//

const ON_ADD_WATCHLIST = 'ON_ADD_WATCHLIST';
export const ON_ADD_WATCHLIST_SUCCESS = 'ON_ADD_WATCHLIST_SUCCESS';
const ON_ADD_WATCHLIST_FAILURE = 'ON_ADD_WATCHLIST_FAILURE';

function onAddWatchlist() {
  return {
    type: ON_ADD_WATCHLIST,
  };
}

function onAddWatchlistSuccess(payload) {
  return {
    type: ON_ADD_WATCHLIST_SUCCESS,
    payload,
  };
}

function onAddWatchlistFailure(payload) {
  return {
    type: ON_ADD_WATCHLIST_FAILURE,
    payload,
  };
}

export const onDoAddWatchlist = (payload) => (dispatch) => {
  dispatch(onAddWatchlist());
  Fetch.post(`${V1}stock/watchlist/`, payload)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onAddWatchlistSuccess(resp.json));
      } else {
        dispatch(onAddWatchlistFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onAddWatchlistFailure(error.message));
    });
};

//= ============================================================================================//
//                                             REMOVE TICKER CODE                               //
//= ============================================================================================//

const ON_REMOVE_WATCHLIST = 'ON_REMOVE_WATCHLIST';
export const ON_REMOVE_WATCHLIST_SUCCESS = 'ON_REMOVE_WATCHLIST_SUCCESS';
const ON_REMOVE_WATCHLIST_FAILURE = 'ON_REMOVE_WATCHLIST_FAILURE';

function onRemoveWatchlist() {
  return {
    type: ON_REMOVE_WATCHLIST,
  };
}

function onRemoveWatchlistSuccess(payload, code) {
  return {
    type: ON_REMOVE_WATCHLIST_SUCCESS,
    payload,
    meta: { code },
  };
}

function onRemoveWatchlistFailure(payload) {
  return {
    type: ON_REMOVE_WATCHLIST_FAILURE,
    payload,
  };
}

export const onDoRemoveWatchlist = (code) => (dispatch) => {
  dispatch(onRemoveWatchlist());
  Fetch.delete(`${V1}stock/watchlist/${code}/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRemoveWatchlistSuccess(resp.json, code));
      } else {
        dispatch(onRemoveWatchlistFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRemoveWatchlistFailure(error.message));
    });
};

//= ============================================================================================//
//                                              GET GROUP LIST BY CODE                          //
//= ============================================================================================//

const ON_GET_GROUP_BY_CODE = 'ON_GET_GROUP_BY_CODE';
const ON_GET_GROUP_BY_CODE_SUCCESS = 'ON_GET_GROUP_BY_CODE_SUCCESS';
const ON_GET_GROUP_BY_CODE_FAILURE = 'ON_GET_GROUP_BY_CODE_FAILURE';

function onGetGroupByode() {
  return {
    type: ON_GET_GROUP_BY_CODE,
  };
}

function onGetGroupByodeSuccess(payload) {
  return {
    type: ON_GET_GROUP_BY_CODE_SUCCESS,
    payload,
  };
}

function onGetGroupByodeFailure(payload) {
  return {
    type: ON_GET_GROUP_BY_CODE_FAILURE,
    payload,
  };
}
export const onDoGetGroupByCode = (id) => (dispatch) => {
  dispatch(onGetGroupByode());
  Fetch.get(`${V1}stock/watchlist/${id}/group/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onGetGroupByodeSuccess(resp.json));
      } else {
        dispatch(onGetGroupByodeFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onGetGroupByodeFailure(error.message));
    });
};

//= ============================================================================================//
//                                           ADD CODE TO SELECTED GROUP                         //
//= ============================================================================================//

const ON_ADD_WATCHLIST_TO_SELECTED_GROUP = 'ON_ADD_WATCHLIST_TO_SELECTED_GROUP';
const ON_ADD_WATCHLIST_TO_SELECTED_GROUP_SUCCESS = 'ON_ADD_WATCHLIST_TO_SELECTED_GROUP_SUCCESS';
const ON_ADD_WATCHLIST_TO_SELECTED_GROUP_FAILURE = 'ON_ADD_WATCHLIST_TO_SELECTED_GROUP_FAILURE';

function onAddWatchlistToSelectedGroup() {
  return {
    type: ON_ADD_WATCHLIST_TO_SELECTED_GROUP,
  };
}

function onAddWatchlistToSelectedGroupSuccess(payload) {
  return {
    type: ON_ADD_WATCHLIST_TO_SELECTED_GROUP_SUCCESS,
    payload,
  };
}

function onAddWatchlistToSelectedGroupFailure(payload) {
  return {
    type: ON_ADD_WATCHLIST_TO_SELECTED_GROUP_FAILURE,
    payload,
  };
}

export const onDoAddWatchlistToSelectedGroup = (payload, code) => (dispatch) => {
  dispatch(onAddWatchlistToSelectedGroup());
  Fetch.post(`${V1}stock/watchlist/${code}/set-group/`, payload)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onAddWatchlistToSelectedGroupSuccess(resp.json));
      } else {
        dispatch(onAddWatchlistToSelectedGroupFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onAddWatchlistToSelectedGroupFailure(error.message));
    });
};

//= ============================================================================================//
//                                          CHANGE POSITION WATCHLIST                           //
//= ============================================================================================//

const ON_CHANGE_WATCHLIST_ORDER = 'ON_CHANGE_WATCHLIST_ORDER';
const ON_CHANGE_WATCHLIST_ORDER_SUCCESS = 'ON_CHANGE_WATCHLIST_ORDER_SUCCESS';
const ON_CHANGE_WATCHLIST_ORDER_FAILURE = 'ON_CHANGE_WATCHLIST_ORDER_FAILURE';

function onChangeWatchlistOrder() {
  return {
    type: ON_ADD_WATCHLIST_TO_SELECTED_GROUP,
  };
}

function onChangeWatchlistOrderSuccess(payload) {
  return {
    type: ON_ADD_WATCHLIST_TO_SELECTED_GROUP_SUCCESS,
    payload,
  };
}

function onChangeWatchlistOrderFailure(payload) {
  return {
    type: ON_ADD_WATCHLIST_TO_SELECTED_GROUP_FAILURE,
    payload,
  };
}

export const onDoChangeWatchlistOrder = (id, payload) => (dispatch) => {
  dispatch(onChangeWatchlistOrder());
  Fetch.put(`${V1}stock/watchlist/group/${id}/`, payload)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onChangeWatchlistOrderSuccess(resp.json));
      } else {
        dispatch(onChangeWatchlistOrderFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onChangeWatchlistOrderFailure(error.message));
    });
};

//= ============================================================================================//
//                                          CHANGE POSITION WATCHLIST                           //
//= ============================================================================================//

const ON_DELETE_SELECTED_WATCHLIST = 'ON_DELETE_SELECTED_WATCHLIST';
const ON_DELETE_SELECTED_WATCHLIST_SUCCESS = 'ON_DELETE_SELECTED_WATCHLIST_SUCCESS';
const ON_DELETE_SELECTED_WATCHLIST_FAILURE = 'ON_DELETE_SELECTED_WATCHLIST_FAILURE';

function onDeleteSelectedWatchlist() {
  return {
    type: ON_DELETE_SELECTED_WATCHLIST,
  };
}

function onDeleteSelectedWatchlistSuccess(payload) {
  return {
    type: ON_DELETE_SELECTED_WATCHLIST_SUCCESS,
    payload,
  };
}

function onDeleteSelectedWatchlistFailure(payload) {
  return {
    type: ON_DELETE_SELECTED_WATCHLIST_FAILURE,
    payload,
  };
}

export const onDoDeleteSelectedWatchlist = (id, payload) => (dispatch) => {
  dispatch(onDeleteSelectedWatchlist());
  Fetch.post(`${V1}stock/watchlist/group/${id}/delete/`, payload)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onDeleteSelectedWatchlistSuccess(resp.json));
      } else {
        dispatch(onDeleteSelectedWatchlistFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onDeleteSelectedWatchlistFailure(error.message));
    });
};

//= ============================================================================================//
//                                          CHANGE POSITION WATCHLIST                           //
//= ============================================================================================//

const ON_GET_WATCHLIST_ID = 'ON_GET_WATCHLIST_ID';
const ON_GET_WATCHLIST_ID_SUCCESS = 'ON_GET_WATCHLIST_ID_SUCCESS';
const ON_GET_WATCHLIST_ID_FAILURE = 'ON_GET_WATCHLIST_ID_FAILURE';

function onGetWatchlistId() {
  return {
    type: ON_GET_WATCHLIST_ID,
  };
}

function onGetWatchlistIdSuccess(payload) {
  return {
    type: ON_GET_WATCHLIST_ID_SUCCESS,
    payload,
  };
}

function onGetWatchlistIdFailure(payload) {
  return {
    type: ON_GET_WATCHLIST_ID_FAILURE,
    payload,
  };
}

export const onDoGetWatchlistId = () => (dispatch) => {
  dispatch(onGetWatchlistId());
  Fetch.get(`${V1}stock/watchlist/group/profile/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onGetWatchlistIdSuccess(resp.json));
      } else {
        dispatch(onGetWatchlistIdFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onGetWatchlistIdFailure(error.message));
    });
};

const INITIAL_STATE = {
  createWatchlistGroup: null,
  createWatchlistGroupError: null,
  createWatchlistGroupSuccess: null,

  watchlistGroup: null,
  watchlistGroupError: null,
  watchlistGroupLoading: null,

  deleteWatchlistGroupLoading: null,
  deleteWatchlistGroupSuccess: null,
  deleteWatchlistGroupError: null,

  updateWatchlistGroup: null,
  updateWatchlistGroupSuccess: null,
  updateWatchlistGroupError: null,

  selectWatchlistGroup: null,
  selectWatchlistGroupSuccess: null,
  selectWatchlistGroupError: null,

  watchlistGroupById: null,
  watchlistGroupByIdError: null,
  watchlistGroupByIdLoading: null,

  watchlistById: null,
  watchlistByIdError: null,
  watchlistByIdLoading: null,

  addWatchlistLoading: null,
  addWatchlistError: null,
  addWatchlistSuccess: null,

  removeWatchlistLoading: null,
  removeWatchlistSuccess: null,
  removeWatchlistError: null,

  groupListByCode: null,
  groupListByCodeError: null,
  groupListByCodeLoading: null,

  addWatchlistToSelectedGroupByCode: null,
  addWatchlistToSelectedGroupByCodeError: null,
  addWatchlistToSelectedGroupByCodeSuccess: null,

  changeOrderWatchlistLoading: null,
  changeOrderWatchlistSuccess: null,
  changeOrderWatchlistError: null,

  deleteSelectedWatchlistLoading: null,
  deleteSelectedWatchlistSuccess: null,
  deleteSelectedWatchlistError: null,

  watchlistId: null,
  watchlistIdLoading: null,
  watchlistIdError: null,
};

const watchlist = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CREATE
    case ON_CREATE_WATCHLIST_GROUP:
      return {
        ...state,
        createWatchlistGroup: true,
        createWatchlistGroupError: null,
        createWatchlistGroupSuccess: null,
      };
    case ON_CREATE_WATCHLIST_GROUP_SUCCESS:
      return {
        ...state,
        createWatchlistGroup: false,
        createWatchlistGroupError: null,
        createWatchlistGroupSuccess: action.payload,
      };
    case ON_CREATE_WATCHLIST_GROUP_FAILURE:
      return {
        ...state,
        createWatchlistGroup: false,
        createWatchlistGroupError: action.payload,
        createWatchlistGroupSuccess: null,
      };

    // GET
    case ON_REQUEST_WATCHLIST_GROUP:
      return {
        ...state,
        watchlistGroup: true,
        watchlistGroupError: null,
        watchlistGroupLoading: true,

        createWatchlistGroup: null,
        createWatchlistGroupError: null,
        createWatchlistGroupSuccess: null,

        deleteWatchlistGroupLoading: null,
        deleteWatchlistGroupSuccess: null,
        deleteWatchlistGroupError: null,
      };
    case ON_REQUEST_WATCHLIST_GROUP_SUCCESS:
      return {
        ...state,
        watchlistGroup: action.payload,
        watchlistGroupError: null,
        watchlistGroupLoading: false,
      };
    case ON_REQUEST_WATCHLIST_GROUP_FAILURE:
      return {
        ...state,
        watchlistGroup: null,
        watchlistGroupError: action.payload,
        watchlistGroupLoading: false,
      };

    // DELETE
    case ON_DELETE_WATCHLIST_GROUP:
      return {
        ...state,
        deleteWatchlistGroupLoading: true,
        deleteWatchlistGroupSuccess: null,
        deleteWatchlistGroupError: null,
      };
    case ON_DELETE_WATCHLIST_GROUP_SUCCESS:
      return {
        ...state,
        deleteWatchlistGroupLoading: false,
        deleteWatchlistGroupSuccess: action.payload,
        deleteWatchlistGroupError: null,
      };
    case ON_DELETE_WATCHLIST_GROUP_FAILURE:
      return {
        ...state,
        deleteWatchlistGroupLoading: false,
        deleteWatchlistGroupSuccess: null,
        deleteWatchlistGroupError: action.payload,
      };

    // UPDATE
    case ON_UPDATE_WATCHLIST_GROUP:
      return {
        ...state,
        updateWatchlistGroup: true,
        updateWatchlistGroupError: null,
        updateWatchlistGroupSuccess: null,
      };
    case ON_UPDATE_WATCHLIST_GROUP_SUCCESS:
      return {
        ...state,
        updateWatchlistGroup: false,
        updateWatchlistGroupError: null,
        updateWatchlistGroupSuccess: action.payload,
      };
    case ON_UPDATE_WATCHLIST_GROUP_FAILURE:
      return {
        ...state,
        updateWatchlistGroup: false,
        updateWatchlistGroupError: action.payload,
        updateWatchlistGroupSuccess: null,
      };

    // SELECT
    case ON_SELECT_WATCHLIST_GROUP:
      return {
        ...state,
        selectWatchlistGroup: true,
        selectWatchlistGroupError: null,
        selectWatchlistGroupSuccess: null,
      };
    case ON_SELECT_WATCHLIST_GROUP_SUCCESS:
      return {
        ...state,
        selectWatchlistGroup: false,
        selectWatchlistGroupError: null,
        selectWatchlistGroupSuccess: action.payload,
      };
    case ON_SELECT_WATCHLIST_GROUP_FAILURE:
      return {
        ...state,
        selectWatchlistGroup: false,
        selectWatchlistGroupError: action.payload,
        selectWatchlistGroupSuccess: null,
      };

    // GET NAME BY ID
    case ON_REQUEST_WATCHLIST_GROUP_BY_ID:
      return {
        ...state,
        watchlistGroupById: true,
        watchlistGroupByIdError: null,
        watchlistGroupByIdLoading: true,
      };
    case ON_REQUEST_WATCHLIST_GROUP_BY_ID_SUCCESS:
      return {
        ...state,
        watchlistGroupById: action.payload,
        watchlistGroupByIdError: null,
        watchlistGroupByIdLoading: false,
      };
    case ON_REQUEST_WATCHLIST_GROUP_BY_ID_FAILURE:
      return {
        ...state,
        watchlistGroupById: null,
        watchlistGroupByIdError: action.payload,
        watchlistGroupByIdLoading: false,
      };
    // GET CODE BY ID
    case ON_REQUEST_WATCHLIST_BY_ID:
      return {
        ...state,
        watchlistById: null,
        watchlistByIdError: null,
        watchlistByIdLoading: true,
      };
    case ON_REQUEST_WATCHLIST_BY_ID_SUCCESS:
      return {
        ...state,
        watchlistById: action.payload.result.group_members,
        watchlistByIdError: null,
        watchlistByIdLoading: false,

        addWatchlistLoading: false,
        addWatchlistError: null,
        addWatchlistSuccess: null,

        removeWatchlistLoading: false,
        removeWatchlistSuccess: null,
        removeWatchlistError: null,
      };
    case ON_REQUEST_WATCHLIST_BY_ID_FAILURE:
      return {
        ...state,
        watchlistById: null,
        watchlistByIdError: action.payload,
        watchlistByIdLoading: false,
      };

    // ADD TICKER CODE
    case ON_ADD_WATCHLIST:
      return {
        ...state,
        addWatchlistLoading: true,
        addWatchlistError: null,
        addWatchlistSuccess: null,
      };
    case ON_ADD_WATCHLIST_SUCCESS:
      return {
        ...state,
        addWatchlistLoading: false,
        addWatchlistError: null,
        addWatchlistSuccess: action.payload,
      };
    case ON_ADD_WATCHLIST_FAILURE:
      return {
        ...state,
        addWatchlistLoading: false,
        addWatchlistError: action.payload,
        addWatchlistSuccess: null,
      };

    // REMOVE TICKER CODE
    case ON_REMOVE_WATCHLIST:
      return {
        ...state,
        removeWatchlistLoading: true,
        removeWatchlistSuccess: null,
        removeWatchlistError: null,
      };
    case ON_REMOVE_WATCHLIST_SUCCESS:
      return {
        ...state,
        removeWatchlistLoading: false,
        removeWatchlistSuccess: action.payload,
        removeWatchlistError: null,
      };
    case ON_REMOVE_WATCHLIST_FAILURE:
      return {
        ...state,
        removeWatchlistLoading: false,
        removeWatchlistSuccess: null,
        removeWatchlistError: action.payload,
      };

    // GET CODE BY ID
    case ON_GET_GROUP_BY_CODE:
      return {
        ...state,
        groupListByCode: null,
        groupListByCodeError: null,
        groupListByCodeLoading: true,
      };
    case ON_GET_GROUP_BY_CODE_SUCCESS:
      return {
        ...state,
        groupListByCode: action.payload,
        groupListByCodeError: null,
        groupListByCodeLoading: false,
      };
    case ON_GET_GROUP_BY_CODE_FAILURE:
      return {
        ...state,
        groupListByCode: null,
        groupListByCodeError: action.payload,
        groupListByCodeLoading: false,
      };

    // ADD CODE TO SELECTED WATCHLIST
    case ON_ADD_WATCHLIST_TO_SELECTED_GROUP:
      return {
        ...state,
        addWatchlistToSelectedGroupByCode: true,
        addWatchlistToSelectedGroupByCodeError: null,
        addWatchlistToSelectedGroupByCodeSuccess: null,
      };
    case ON_ADD_WATCHLIST_TO_SELECTED_GROUP_SUCCESS:
      return {
        ...state,
        addWatchlistToSelectedGroupByCode: false,
        addWatchlistToSelectedGroupByCodeError: null,
        addWatchlistToSelectedGroupByCodeSuccess: action.payload,
      };
    case ON_ADD_WATCHLIST_TO_SELECTED_GROUP_FAILURE:
      return {
        ...state,
        addWatchlistToSelectedGroupByCode: false,
        addWatchlistToSelectedGroupByCodeError: action.payload,
        addWatchlistToSelectedGroupByCodeSuccess: null,
      };

    // CHANGE WATCHLIST ORDER
    case ON_CHANGE_WATCHLIST_ORDER:
      return {
        ...state,
        changeOrderWatchlistLoading: true,
        changeOrderWatchlistSuccess: null,
        changeOrderWatchlistError: null,
      };
    case ON_CHANGE_WATCHLIST_ORDER_SUCCESS:
      return {
        ...state,
        changeOrderWatchlistLoading: false,
        changeOrderWatchlistSuccess: null,
        changeOrderWatchlistError: action.payload,
      };
    case ON_CHANGE_WATCHLIST_ORDER_FAILURE:
      return {
        ...state,
        changeOrderWatchlistLoading: false,
        changeOrderWatchlistSuccess: null,
        changeOrderWatchlistError: action.payload,
      };

    // DELETE SELECTED WATCHLIST ORDER
    case ON_DELETE_SELECTED_WATCHLIST:
      return {
        ...state,
        deleteSelectedWatchlistLoading: true,
        deleteSelectedWatchlistSuccess: null,
        deleteSelectedWatchlistError: null,
      };
    case ON_DELETE_SELECTED_WATCHLIST_SUCCESS:
      return {
        ...state,
        deleteSelectedWatchlistLoading: false,
        deleteSelectedWatchlistSuccess: action.payload,
        deleteSelectedWatchlistError: null,
      };
    case ON_DELETE_SELECTED_WATCHLIST_FAILURE:
      return {
        ...state,
        deleteSelectedWatchlistLoading: false,
        deleteSelectedWatchlistSuccess: null,
        deleteSelectedWatchlistError: action.payload,
      };

    // GET WATCHLIST ID
    case ON_GET_WATCHLIST_ID:
      return {
        ...state,
        watchlistIdLoading: true,
        watchlistId: null,
        watchlistIdError: null,
      };
    case ON_GET_WATCHLIST_ID_SUCCESS:
      return {
        ...state,
        watchlistIdLoading: false,
        watchlistId: action.payload.result.selected,
        watchlistIdError: null,
      };
    case ON_GET_WATCHLIST_ID_FAILURE:
      return {
        ...state,
        watchlistIdLoading: false,
        watchlistId: null,
        watchlistIdError: action.payload,
      };

    default:
      return state;
  }
};

export default watchlist;
